/**
 * A switch, for every yes/no in Settings (OPS-002, DESIGN.md radii).
 *
 * A native `<input type="checkbox">` renders as the platform's own control,
 * and the platform's own control is a light-grey box on a light-grey field —
 * in dark mode it very nearly disappears, which is how a settings screen ends
 * up with rows nobody can tell the state of. Found by looking at the page in
 * dark mode rather than by reading it.
 *
 * It is a `<button role="switch">` rather than a restyled checkbox: styling a
 * checkbox means `appearance: none`, which throws away the semantics and then
 * borrows them back with ARIA anyway. A button with `aria-checked` is what a
 * screen reader is looking for, gets the focus ring for free, and cannot fall
 * back to an unstyled box if the CSS fails to load.
 */
export default function Toggle({ checked, onChange, label, describedBy, disabled = false }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      aria-describedby={describedBy}
      disabled={disabled}
      className={`toggle ${checked ? 'on' : ''}`}
      onClick={() => onChange(!checked)}
    >
      <span className="toggle-knob" aria-hidden="true" />
    </button>
  )
}
